import React from "react";
import { Row } from "react-bootstrap";
import kuhoo from "../../assets/kuhoo.gif";
import InfoContainer from "./widgets/info_container";

const ExperienceStack = () => {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <InfoContainer
        title="Kuhoo Edufintech (SDE I)"
        description="Working on different portals, like Loan Operating System(LOS), Student App, KuhooNest fixing productions bugs, developing new features, integrating automations and many more using Flutter, Dart, BLoC and TDD Environments "
        type="Work exp:"
        number="Currently working"
        imageSrc={kuhoo}
      ></InfoContainer>
      <InfoContainer
        title="Kuhoo Edufintech (Internship)"
        description="Worked on Partner Onboarding Portal with Flutter, BLoC, and TDD environment, RCA and Bug fixes "
        type="Work exp:"
        number="5 months"
        imageSrc={kuhoo}
      ></InfoContainer>
    </Row>
  );
};

export default ExperienceStack;
